export default () => {
  const forms = document.querySelectorAll('.wpcf7-form');

  forms.forEach((form) => {
    const inputs = form.querySelectorAll('input:not([type="submit"])');

    inputs.forEach((input) => {
      input.addEventListener('keydown', (event) => {
        if (event.code === 'Enter') {
          event.preventDefault();
        }
      });
    });
  });
};
